// UC Davis's undergraduate majors (#2596, founder 2026-09-30: "majors offered
// by the college in the public page"). Read on 2026-09-30 from the official UC
// Davis General Catalog: every bachelor's degree on Programs & Degrees A-Z
// (catalog.ucdavis.edu/departments-programs-degrees/), grouped by the college its
// program page names. Degrees as the catalog abbreviates them (AB, BS). Left
// out: minors, graduate degrees, two integrated BS/MS programs, and two majors
// whose pages say they no longer accept new students. No flags: the college
// file holds no source for extra requirements. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "university-of-california-davis",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in UC Davis's official General Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, graduate programs and majors closed to new students are left out.",
    "groups": [
        {
            "name": "College of Agricultural & Environmental Sciences",
            "source": {
                "label": "UC Davis General Catalog 2026-27, Departments, Programs, & Degrees (Programs & Degrees A-Z)",
                "url": "https://catalog.ucdavis.edu/departments-programs-degrees/"
            },
            "majors": [
                {
                    "name": "Agricultural & Environmental Education",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural & Environmental Sciences, Individual",
                    "degree": "BS",
                    "note": "Individual major, designed by the student"
                },
                {
                    "name": "Agricultural & Environmental Technology",
                    "degree": "BS"
                },
                {
                    "name": "Animal Biology",
                    "degree": "BS"
                },
                {
                    "name": "Animal Science & Management",
                    "degree": "BS"
                },
                {
                    "name": "Animal Science",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric Science",
                    "degree": "BS"
                },
                {
                    "name": "Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Clinical Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Community & Regional Development",
                    "degree": "BS"
                },
                {
                    "name": "Entomology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Policy Analysis & Planning",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science & Management",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Toxicology",
                    "degree": "BS"
                },
                {
                    "name": "Food Science",
                    "degree": "BS"
                },
                {
                    "name": "Global Disease Biology",
                    "degree": "BS"
                },
                {
                    "name": "Human Development",
                    "degree": "BS"
                },
                {
                    "name": "Hydrology",
                    "degree": "BS"
                },
                {
                    "name": "International Agricultural Development",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Managerial Economics",
                    "degree": "BS"
                },
                {
                    "name": "Marine & Coastal Science",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition Science",
                    "degree": "BS"
                },
                {
                    "name": "Plant Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Agriculture & Food Systems",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Environmental Design",
                    "degree": "BS"
                },
                {
                    "name": "Viticulture & Enology",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife, Fish & Conservation Biology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Biological Sciences",
            "source": {
                "label": "UC Davis General Catalog 2026-27, Departments, Programs, & Degrees (Programs & Degrees A-Z)",
                "url": "https://catalog.ucdavis.edu/departments-programs-degrees/"
            },
            "majors": [
                {
                    "name": "Biochemistry & Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "AB"
                },
                {
                    "name": "Biological Sciences, Individual",
                    "degree": "AB",
                    "note": "Individual major, designed by the student"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences, Individual",
                    "degree": "BS",
                    "note": "Individual major, designed by the student"
                },
                {
                    "name": "Cell Biology",
                    "degree": "BS"
                },
                {
                    "name": "Evolution, Ecology & Biodiversity",
                    "degree": "AB"
                },
                {
                    "name": "Evolution, Ecology & Biodiversity",
                    "degree": "BS"
                },
                {
                    "name": "Genetics & Genomics",
                    "degree": "BS"
                },
                {
                    "name": "Human Biology",
                    "degree": "BS"
                },
                {
                    "name": "Molecular & Medical Microbiology",
                    "degree": "AB"
                },
                {
                    "name": "Molecular & Medical Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Neurobiology, Physiology, & Behavior",
                    "degree": "BS"
                },
                {
                    "name": "Plant Biology",
                    "degree": "AB"
                },
                {
                    "name": "Plant Biology",
                    "degree": "BS"
                },
                {
                    "name": "Systems & Synthetic Biology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UC Davis General Catalog 2026-27, Departments, Programs, & Degrees (Programs & Degrees A-Z)",
                "url": "https://catalog.ucdavis.edu/departments-programs-degrees/"
            },
            "majors": [
                {
                    "name": "Aerospace Science & Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biochemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biological Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science & Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science & Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Letters & Science",
            "source": {
                "label": "UC Davis General Catalog 2026-27, Departments, Programs, & Degrees (Programs & Degrees A-Z)",
                "url": "https://catalog.ucdavis.edu/departments-programs-degrees/"
            },
            "majors": [
                {
                    "name": "African American & African Studies",
                    "degree": "AB"
                },
                {
                    "name": "American Studies",
                    "degree": "AB"
                },
                {
                    "name": "Anthropology",
                    "degree": "AB"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "AB"
                },
                {
                    "name": "Art Studio",
                    "degree": "AB"
                },
                {
                    "name": "Asian American Studies",
                    "degree": "AB"
                },
                {
                    "name": "Chemical Physics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "AB"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chicana/Chicano Studies",
                    "degree": "AB"
                },
                {
                    "name": "Chinese",
                    "degree": "AB"
                },
                {
                    "name": "Cinema & Digital Media",
                    "degree": "AB"
                },
                {
                    "name": "Classical Civilization",
                    "degree": "AB"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "AB"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "AB"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "AB"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Design",
                    "degree": "AB"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "AB"
                },
                {
                    "name": "Economics",
                    "degree": "AB"
                },
                {
                    "name": "English",
                    "degree": "AB"
                },
                {
                    "name": "French",
                    "degree": "AB"
                },
                {
                    "name": "Gender, Sexuality, & Women's Studies",
                    "degree": "AB"
                },
                {
                    "name": "Geology",
                    "degree": "AB"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "AB"
                },
                {
                    "name": "History",
                    "degree": "AB"
                },
                {
                    "name": "International Relations",
                    "degree": "AB"
                },
                {
                    "name": "Italian",
                    "degree": "AB"
                },
                {
                    "name": "Japanese",
                    "degree": "AB"
                },
                {
                    "name": "Letters & Science, Individual",
                    "degree": "AB",
                    "note": "Individual major, designed by the student"
                },
                {
                    "name": "Letters & Science, Individual",
                    "degree": "BS",
                    "note": "Individual major, designed by the student"
                },
                {
                    "name": "Linguistics",
                    "degree": "AB"
                },
                {
                    "name": "Mathematical & Scientific Computation",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Analytics & Operations Research",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "AB"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Medicinal Chemistry & Drug Design",
                    "degree": "BS"
                },
                {
                    "name": "Medieval & Early Modern Studies",
                    "degree": "AB"
                },
                {
                    "name": "Middle East/South Asia Studies",
                    "degree": "AB"
                },
                {
                    "name": "Music",
                    "degree": "AB"
                },
                {
                    "name": "Native American Studies",
                    "degree": "AB"
                },
                {
                    "name": "Philosophy",
                    "degree": "AB"
                },
                {
                    "name": "Physics",
                    "degree": "AB"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "AB"
                },
                {
                    "name": "Political Science-Public Service",
                    "degree": "AB"
                },
                {
                    "name": "Psychology",
                    "degree": "AB"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "AB"
                },
                {
                    "name": "Russian",
                    "degree": "AB"
                },
                {
                    "name": "Science & Technology Studies",
                    "degree": "AB"
                },
                {
                    "name": "Sociology",
                    "degree": "AB"
                },
                {
                    "name": "Sociology-Organizational Studies",
                    "degree": "AB"
                },
                {
                    "name": "Spanish",
                    "degree": "AB"
                },
                {
                    "name": "Statistics",
                    "degree": "AB"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Theatre & Dance",
                    "degree": "AB"
                }
            ]
        },
        {
            "name": "Graduate School of Management",
            "source": {
                "label": "UC Davis General Catalog 2026-27, Departments, Programs, & Degrees (Programs & Degrees A-Z)",
                "url": "https://catalog.ucdavis.edu/departments-programs-degrees/"
            },
            "majors": [
                {
                    "name": "Business",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
